import VafActivityDescription from "../steps/VafActivityDescription.jsx";
import VafIndustryActivity from "../steps/VafIndustryActivity.jsx";
import VafIndustrySelect from "../steps/VafIndustrySelect.jsx";

const guardNextStep = (onNext, nextDisabled) => () => {
  if (nextDisabled) {
    return;
  }
  onNext?.();
};

const getIndustrySelectFooterNav = (self, onBack, onNext) => {
  const selectedIndustry = self.props.company_store?.industry || "";
  const industryInput = self.props.company_store?.industryinput || "";
  const isOtherSelected = selectedIndustry === "other";
  const nextDisabled =
    !selectedIndustry || (isOtherSelected && !String(industryInput).trim());

  return {
    onBack,
    onNext: guardNextStep(onNext, nextDisabled),
    nextDisabled,
  };
};

/** Footer config for the active VafFlow step — VafContactPage/VafSuccessScreen/GeneralError render their own nav. */
export const getVafStepFooterNav = (self, activeStep, steps) => {
  const stepComponent = steps[activeStep]?.component;
  if (!stepComponent) {
    return null;
  }

  if (stepComponent === VafIndustrySelect) {
    return getIndustrySelectFooterNav(
      self,
      // No back button on a direct landing — there's nowhere sensible to send it.
      self.state.cameFromNewCompanyType ? self.handleVafIndustrySelectBack : undefined,
      self.handleVafIndustrySelectNext,
    );
  }

  if (stepComponent === VafIndustryActivity) {
    return {
      onBack: self.handleVafIndustryActivityBack,
      onNext: self.handleVafIndustryActivityNext,
      nextDisabled: false,
    };
  }

  if (stepComponent === VafActivityDescription) {
    const nextDisabled = !String(self.props.company_store?.reqMessage || "").trim();
    return {
      onBack: self.handleVafActivityDescriptionBack,
      onNext: guardNextStep(self.handleVafActivityDescriptionNext, nextDisabled),
      nextDisabled,
    };
  }

  return null;
};
